import { replace } from 'react-router-redux';

import { setWindowLocation } from '@eb/http';

import {
    trackSignInConfirmationAcknowledged,
    trackSignInConfirmationRejected,
} from './gaTracking';

// Signin Confirmation Actions
export const acknowledgeMessage = () => (dispatch, getState) => {
    const state = getState();
    trackSignInConfirmationAcknowledged({ state });
    dispatch(replace('/signin'));
};

export const rejectMessage = (forwardURL) => (dispatch, getState) => {
    const state = getState();
    trackSignInConfirmationRejected({ state });
    setWindowLocation(forwardURL);
};
